import { render, staticRenderFns } from "./faqPurple.vue?vue&type=template&id=7ff2a3c0"
import script from "./faqPurple.vue?vue&type=script&lang=js"
export * from "./faqPurple.vue?vue&type=script&lang=js"
import style0 from "./faqPurple.vue?vue&type=style&index=0&id=7ff2a3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports